import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { initialSettings } from "src/Core/ViewModels/settings/Setting";

const SideMenu: React.FC = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<string | null>("/settings/general");
    const handleSelect = (key: string) => {
        navigate(key);
    };

    return (
        <div className="admin-side-menu-wrapper settings-sidebar">
            <Nav
                defaultActiveKey="/settings/general"
                className="flex-column"
                onSelect={key => handleSelect(key)}
                style={{ cursor: "pointer" }}
            >
                {initialSettings.map((data, key) => {
                    return (
                        <>
                            <Nav.Link
                                className={
                                    "settings-menu-item nav-link" +
                                    (activeTab === `/settings/${data.route}` ? " active" : "")
                                }
                                eventKey={`/settings/${data.route}`}
                                key={key}
                                onClick={() => setActiveTab(`/settings/${data.route}`)}
                            >
                                {data.title}
                            </Nav.Link>
                        </>
                    );
                })}
            </Nav>
        </div>
    );
};

export default SideMenu;
